module.exports = __webpack_public_path__ + "img/logo-symbol.7f5f93fb.svg";